// Development-only logger utility
// All logging should use this instead of console.log directly
// In production, all logging functions return immediately without doing anything

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]): void => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  warn: (...args: any[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  error: (...args: any[]): void => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  info: (...args: any[]): void => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  debug: (...args: any[]): void => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  group: (label: string): void => {
    if (isDevelopment) {
      console.group(label);
    }
  },
  groupEnd: (): void => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },
  table: (data: any): void => {
    if (isDevelopment) {
      console.table(data);
    }
  },
};
